import { BACKEND_HOST_MAIN } from 'store/api.constants';
import ApiUtilities from 'helpers/ApiUtils';
import { PaginatedListResult } from 'store/base';
import {
  AddressBookItemContactListResponseViewModel,
  AddressBookItemResponseViewModel,
  AddressBookItemsRequestViewModel,
  AddressBookItemsResponseViewModel,
} from '../App/routes/Tenant/AddressBook/ViewModels';
import AddressBookItemContactCreateOrUpdateResponseViewModel from '../viewModels/address/AddressBookItemContactCreateOrUpdateResponseViewModel';
import AddressBookWithContactsResponseViewModel from '../viewModels/address/AddressBookWithContactsResponseViewModel';

function getRoot() {
  return `${BACKEND_HOST_MAIN()}api/address-book`;
}

export class AddressBookApi {
  public static getList(
    params: AddressBookItemsRequestViewModel,
  ): Promise<PaginatedListResult<AddressBookItemsResponseViewModel>> {
    return ApiUtilities.handleGet<PaginatedListResult<AddressBookItemsResponseViewModel>>(
      getRoot(),
      {
        ...params,
      },
    );
  }

  public static getSingle(id: string): Promise<AddressBookItemResponseViewModel | null> {
    return ApiUtilities.handleGet<AddressBookItemResponseViewModel>(`${getRoot()}/${id}`);
  }

  public static add(formValues: AddressBookItemResponseViewModel): Promise<string> {
    return ApiUtilities.handlePost<string>(getRoot(), formValues);
  }

  public static update(id: string, formValues: AddressBookItemResponseViewModel) {
    return ApiUtilities.handlePut<boolean>(`${getRoot()}/${id}`, formValues);
  }

  public static delete(id: string) {
    return ApiUtilities.handleDelete(`${getRoot()}/${id}`);
  }

  public static getContactList(id: string): Promise<AddressBookItemContactListResponseViewModel[]> {
    return ApiUtilities.handleGet<AddressBookItemContactListResponseViewModel[]>(
      `${getRoot()}/${id}/contact`,
      {},
    );
  }

  public static addContact(
    id: string,
    formValues: AddressBookItemContactCreateOrUpdateResponseViewModel,
  ): Promise<number> {
    return ApiUtilities.handlePost<number>(`${getRoot()}/${id}/contact`, formValues);
  }

  public static updateContact(
    id: string,
    formValues: AddressBookItemContactCreateOrUpdateResponseViewModel,
  ) {
    return ApiUtilities.handlePut<boolean>(`${getRoot()}/${id}/contact/`, formValues);
  }

  public static getContact(
    id: string,
    contactId: number,
  ): Promise<AddressBookItemContactCreateOrUpdateResponseViewModel> {
    return ApiUtilities.handleGet<AddressBookItemContactCreateOrUpdateResponseViewModel>(
      `${getRoot()}/${id}/contact/${contactId}`,
      {},
    );
  }

  public static deleteContact(id: string, contactId: number): Promise<boolean> {
    return ApiUtilities.handlePost<boolean>(`${getRoot()}/${id}/contact/${contactId}/delete`, {});
  }

  public static getCustomerDefaultAddress(
    customerId: string,
  ): Promise<AddressBookWithContactsResponseViewModel | null> {
    return ApiUtilities.handleGet<AddressBookWithContactsResponseViewModel>(
      `${getRoot()}/customer-loading-address/?customerId=${customerId}`,
    );
  }
}
